module.exports = __webpack_public_path__ + "static/EPD-lamppost_mobile_banner-low-04051a5e11135e2238e77853ced76379.png";